(function(){
  // Match the newsletter page exactly
  if (window.location.pathname === '/pages/join-our-newsletter') {
    // Add class to <html> for CSS hook
    document.documentElement.classList.add('mw-hide-footer');

    // Hide footer immediately (prevents flash)
    function hideFooterNow() {
      var selectors = [
        '#shopify-section-footer',
        'footer',
        '.footer',
        '.site-footer',
        '[id*="footer"]'
      ];
      selectors.forEach(function(sel){
        var el = document.querySelector(sel);
        if (el) el.style.display = 'none';
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', hideFooterNow);
    } else {
      hideFooterNow();
    }
  }
})();
